<div class="vsa-container">
  @if (isLocalMode) {
    <div class="local-mode-banner" data-local-mode-banner>
      Local Docker Mode
    </div>
  }
  <div class="header-container">
    <app-header [appTitle]="title"></app-header>
  </div>
  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>

  <loading-panel></loading-panel>

</div>
